import React, { ReactElement } from 'react';
import { IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react';

interface RowActionButtonProps extends Omit<IconButtonProps, 'aria-label' | 'icon'> {
  label: string;
  icon: ReactElement;
  tone?: 'default' | 'destructive';
}

export const RowActionButton = ({
  label,
  icon,
  tone = 'default',
  ...rest
}: RowActionButtonProps) => (
  <Tooltip label={label} openDelay={300}>
    <IconButton
      aria-label={label}
      icon={icon}
      size="xs"
      variant="ghost"
      color="content.subtle"
      _hover={
        tone === 'destructive'
          ? { bg: 'state.destructiveSurface', color: 'state.destructive' }
          : { bg: 'surface.selected', color: 'content.strong' }
      }
      {...rest}
    />
  </Tooltip>
);
